import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { OAuthService } from 'angular-oauth2-oidc';
import { ErrorService } from '../services/error.service';
import { AlertifyService } from '@liebherr/old-sage-ui';
import { environment } from '../../../environments/environment';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private translateService: TranslocoService,
        private notificationService: AlertifyService,
        private oauthService: OAuthService,
        private errorService: ErrorService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((errorResponse: HttpErrorResponse) => {
                console.warn('intercept', errorResponse);

                if (errorResponse.status === 401 || errorResponse.status === 405) {
                    if (!environment.e2e) {
                        this.oauthService.logOut();
                        setTimeout(() => {
                            this.notificationService.log(this.translateService.translate('ERROR.SESSION_EXPIRED'), AlertifyService.LOG);
                        }, 500);
                    }
                } else if (errorResponse.status === 403) {
                    this.notificationService.log(this.translateService.translate('ERROR.PERMISSION_DENIED'), AlertifyService.LOG);
                } else if (errorResponse.status === 404) {
                    // throw 404 - let application handle
                    throwError(errorResponse);
                } else if (errorResponse.status !== 400) {
                    this.errorService.addError(errorResponse);
                    this.router.navigate(['/error-page']);
                } else {
                    let exceptions: any[] = [];
                    try {
                        exceptions = errorResponse.error;
                        // eslint-disable-next-line no-empty
                    } catch (e) {}
                    if (exceptions && Array.isArray(exceptions)) {
                        exceptions.forEach((ex) => {
                            // passed-through validation exceptions from hibernate or java
                            // package-names are uppercased on serverside:
                            // 'org.hibernate.validator.constraints', 'javax.validation.constraints'
                            if (
                                ex.msg !== undefined &&
                                (ex.msg.indexOf('ORG_HIBERNATE_VALIDATOR_CONSTRAINTS') > -1 ||
                                    ex.msg.indexOf('JAVAX_VALIDATION_CONSTRAINTS') > -1)
                            ) {
                                this.notificationService.log(
                                    this.translateService.translate('ERROR.GENERAL_VALIDATION_ERROR'),
                                    AlertifyService.ERROR
                                );
                            } else {
                                if (ex.field && ex.field.length > 0 && ex.msg !== undefined) {
                                    const translatedField = this.translateService.translate(ex.field.toUpperCase());
                                    const translatedMsg = this.translateService.translate(ex.msg, { field: translatedField });
                                    this.notificationService.log(translatedMsg, AlertifyService.ERROR);
                                } else if (ex.msg !== undefined) {
                                    const translatedMsgKey = this.translateService.translate(ex.msg);
                                    this.notificationService.log(translatedMsgKey, AlertifyService.ERROR, 'bottom left');
                                } else {
                                    this.notificationService.log(
                                        this.translateService.translate('ERROR.GENERAL_ERROR'),
                                        AlertifyService.ERROR,
                                        'bottom left'
                                    );
                                }
                            }
                        });
                    } else {
                        // could not parse defined exception
                        this.errorService.addError(errorResponse);
                        this.router.navigate(['/error-page']);
                    }
                }
                return throwError(errorResponse);
            })
        );
    }
}
